import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title?: string;
  description?: string;
  path?: string;
}

const SEOHead = ({
  title = "Circle. — Your relationship memory.",
  description = "Circle is the relationship memory for professionals who take their relationships seriously. Smart reminders, personal messages, and a growing record of the people who matter most.",
  path = "/",
}: SEOHeadProps) => {
  const url = `https://circle.dearestly.co${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHead;
